import { Location } from './location.model';

export class Zone {
  id: number;
  name: string;
  other: boolean;

  locations: Location[];
}
